import { gql } from '@apollo/client'

export const GET_VIDEOS_BY_TERRITORY = gql`
  query getVideosByTerritory($territoryId: ID!, $filters: TerritoryMostEngagedFilters, $limit: Int) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryMostEngaged {
        posts(limit: $limit, filters: $filters) {
          postId
          provider
          title
          thumbnail
          publishedAt
          tags
          views
          hasViewsReaction
          likes
          hasLikesReaction
          comments
          hasCommentsReaction
          live {
            endTime
            scheduledTime
            startTime
            state

            performance {
              time
              concurrentViewers
              likes
            }
          }
          creatorId
          isPublicity
          creator {
            ... on Creator {
              thumbnail
              title
              groupId
              creatorId
              provider
            }
            ... on CreatorIncompleteIN {
              title
            }
            ... on CreatorIncompleteTT {
              title
            }
            ... on CreatorIncompleteYT {
              title
            }
            ... on CreatorIncompleteFB {
              title
            }
            ... on CreatorIncompleteTW {
              title
            }
            ... on CreatorPublic {
              title
            }
          }
        }
      }
    }
  }
`
